import type { RouteObject } from "react-router-dom";

import type { OrganizationTier } from "gitpod-next-api/gitpod/v1/organization_pb";

export type MenuItem = {
    label: string;
    section: string;
    to: string;
    isAdminRole?: boolean;
    featureFlag?: string;
    hiddenOnTiers?: OrganizationTier[];
    hidden?: () => { value: boolean; loading?: boolean };
    /** Short text badge shown after the label (e.g. "Experimental") */
    badge?: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isMenuItem(value: any): value is MenuItem {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
        value &&
        typeof value.label === "string" &&
        typeof value.section === "string" &&
        typeof value.to === "string" &&
        (typeof value.isAdminRole === "boolean" || value.isAdminRole === undefined)
    );
}

export const populateMenuFromRoute = (route: RouteObject): MenuItem[] => {
    const menu: MenuItem[] = [];
    if (route.children) {
        for (const child of route.children) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const { handle } = child;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const menuItem = handle?.menuItem;
            if (isMenuItem(menuItem)) {
                menu.push(menuItem);
                handle.menu = menu;
            }
        }
    }
    return menu;
};
